module.exports = "<p>\r\n  Verificando el usuario ...\r\n</p>\r\n"